import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
//import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//import { BsModalService, } from 'ngx-bootstrap/modal';
import { CompetencesService } from '../../../services/competences.service';
import { Competence } from '../../../models/competence.model';
import $ from "jquery";
import { Programme } from '../../../models/programme.model';

@Component({
  selector: 'competences-modal-content',
  templateUrl: './competences.modal.component.html',
  styleUrls: ['./competences.modal.component.scss']
})

export class CompetencesModalComponent implements OnInit {
  @Input() competence: Competence;
  @Input() programme: Programme;
  form: FormGroup;
  service: CompetencesService;
  afficherMessage: boolean = false;
  afficherMessageNumero: boolean = false;
  isLoading: boolean = false;
  isNewCompetence: boolean;
  codeValide: boolean = true;
  competencesPareilles: Array<Competence>;

  constructor(public bsModalRef: BsModalRef,
    fb: FormBuilder,
    service: CompetencesService) {
    this.form = fb.group({
      "competenceId": [],
      "code": ["", Validators.required],
      "enonce": ["", Validators.required],
      "numero": ["", Validators.required],
      "programmeId": [],
    });
    this.service = service;
  }

  ngOnInit() {
    if (!this.competence) {
      this.isNewCompetence = true;
      this.competence = {
        competenceId: -1,
        code: '',
        enonce: '',
        numero: null,
        programmeId: this.programme.programmeId,
        programme: this.programme,
      };
    } else {
      this.isNewCompetence = false;
    }

  }

  verifierSiCodeValide(code: string): void {
    if (code == " ") {
      this.form.controls.code.setValue("");
      code = "";
    }
    if (code != "") {
      this.afficherMessage = false;
      this.service.competenceExist(code).subscribe(x => {
        this.competencesPareilles = x;
        var isDoublon = false;
        var enonce = "";
        for (let i = 0; i < this.competencesPareilles.length; i++) {
          if (this.competencesPareilles[i].programmeId == this.programme.programmeId) {
            isDoublon = true;
          }
          enonce = this.competencesPareilles[i].enonce;
        }
        // Doublon dans le meme programme
        if (isDoublon == true) {
          this.afficherMessage = true;
          return;
        }
        if (enonce != "") {
          this.competence.enonce = enonce;
        }
        this.afficherMessage = false;
      });
    }
  }

  verifierSiNumeroExiste(numero: number): void {
    if (numero > 0) {
      this.afficherMessageNumero = false;
      this.service.numeroCompetenceExist(numero, this.programme.programmeId, this.competence.competenceId).subscribe(x => {
        if (x == true) this.afficherMessageNumero = true;
        else this.afficherMessageNumero = false;
      });
    }
  }

  effacerMessageErreur() {
    this.afficherMessageNumero = false;
  }


  onSubmit() {
    if (!this.form.dirty) {
      this.bsModalRef.hide();
      return;
    }
    if (this.afficherMessage == true || this.afficherMessageNumero == true) return;
    this.isLoading = true;
    this.competence.enonce = this.competence.enonce.trim();
    if (!this.isNewCompetence) {
      this.service.updateCompetence(this.competence.competenceId, this.competence).subscribe(() => {
        this.isLoading = false;
        this.bsModalRef.hide();
      });
    } else {
      this.service.createCompetence(this.competence).subscribe(() => {
        this.isLoading = false;
        this.bsModalRef.hide()
      });
    }
  }

  supprimer() {
    this.isLoading = true;
    this.service.deleteCompetence(this.competence.competenceId).subscribe(() => {
      this.isLoading = false;
      this.bsModalRef.hide();
    });
  }

  cancel() {
    this.form.reset();
    this.bsModalRef.hide();
  }
}
